import httpClient from "@/httpClient"

const getPattern = () => httpClient.get('{currentCompanySlug}/activity-stream/handlers-config')
const appConfig = (company) => httpClient.get(`${company}/suppliers/${company}/application-configuration`)

export default {
  getPattern,
  appConfig,
}
